module.exports = "<p> autenticando... </p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.html
// module id = ./src/app/login/login.component.html
// module chunks = main